import { OMNIBUS_TYPES } from '@/modules/plan/PlanSetup/AccountFunding/AccountFundingParams/hooks/useAccountFundingParamsFields';
import { PLAN_SETUP_FIELD } from '@/modules/plan/PlanSetup/PlanSetup.constants';

export const shouldExcludeEOYFields = (fundingMethod?: string | null, omnibus?: string | null) => omnibus === OMNIBUS_TYPES.HSA;

export const filterEOYFields = (fields: string[], fundingMethod?: string | null, omnibus?: string | null) => {
  if (!shouldExcludeEOYFields(fundingMethod, omnibus)) return fields;
  return fields.filter(field => 
    field !== PLAN_SETUP_FIELD.EOY_PLAN_RECONCILIATION && 
    field !== PLAN_SETUP_FIELD.EOY_PLAN_RECONCILIATION_DELAY_DAYS
  );
};
